import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../@core/http.service';
import { rejects } from 'assert';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AppsService {

  private _apps$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  get apps$() {
    return this._apps$.asObservable();
  }
  get apps() {
    return this._apps$.getValue();
  }
  set apps(value) {
    this._apps$.next(value);
  }
  private _appLang$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  get appLang$() {
    return this._appLang$.asObservable();
  }
  get appLang() {
    return this._appLang$.getValue();
  }
  set appLang(value) {
    this._appLang$.next(value);
  }
  private _haveUpdate$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  get haveUpdate$() {
    return this._haveUpdate$.asObservable();
  }
  get haveUpdate() {
    return this._haveUpdate$.getValue();
  }
  set haveUpdate(value) {
    this._appLang$.next(value);
  }

  constructor(
    private http: HttpService
  ) { }

  loadWordsColumns() {
    return new Promise((resolve, reject) => {
      this.http.get('/words/columns').subscribe((res) => {
        if (res && res.success === true) {
          resolve(res.data);
        }
      }, (err) => {
        reject(err);
      });

    })
  }

  clear() {
    this._apps$.next(null);
    this._appLang$.next(null);
  }

  getWordsList(requestParams?): Observable<any> {
    if (!requestParams) {
      requestParams = { page: 0, limit: 10 };
    }

    let params = new HttpParams();

    if ('order' in requestParams) {
      params = params.append(`order[${requestParams.order.active}]`, requestParams.order.direction.toUpperCase());
    }
    if ('page' in requestParams) {
      params = params.append('page', requestParams.page.toString());
    }
    if ('limit' in requestParams) {
      params = params.append('limit', requestParams.limit.toString());
    }

    return this.http.get(`/words/list`, { params }, this.appLang);
  }

  loadUnitsColumns() {
    return new Promise((resolve, reject) => {
      this.http.get('/units/columns').subscribe((res) => {
        if (res && res.success === true) {
          resolve(res.data);
        }
      }, (err) => {
        reject(err);
      });

    })
  }

  checkUpdate() {
    setInterval(() => {
      if (this.appLang) {
        this.http.get('/apps/checkUpdate', {}, this.appLang).subscribe(data => {
          this._haveUpdate$.next(data?.data);
        });
      }
    }, 2000);
  }

  getUnitsList(requestParams?): Observable<any> {
    if (!requestParams) {
      requestParams = { page: 0, limit: 10 };
    }

    let params = new HttpParams();

    if ('order' in requestParams) {
      params = params.append(`order[${requestParams.order.active}]`, requestParams.order.direction.toUpperCase());
    }
    if ('page' in requestParams) {
      params = params.append('page', requestParams.page.toString());
    }
    if ('limit' in requestParams) {
      params = params.append('limit', requestParams.limit.toString());
    }

    return this.http.get(`/units/list`, { params }, this.appLang);
  }

  showUpdate(opt: boolean) {
    // this.lastUpdate.next(opt);
  }

  checkHeader(table, headers) {

    return new Promise((resolve, reject) => {
      this.http.get(`/${table}/columns`).subscribe((res) => {

        for (var i = 0; i < headers.length; i++) {
          if (res.data.indexOf(headers[i]) === -1) {
            reject(false);
          }
        }
        resolve(true);
      }, (err) => {
        reject(err);
      });
    });
  }

  getApps() {
    this.http.get('/apps').subscribe((data) => {
      this.apps = data?.data;
    });
  }

  deleteApp(id: number) {
    return new Promise((resolve, rejects) => {
      this.http.delete(`/apps/${id}`).subscribe((data) => {
        if (data?.success) {
          resolve(true);
        }
      }, (error) => {
        rejects(error);
      })
    })
  }

  getAchivementsList(requestParams?): Observable<any> {
    if (!requestParams) {
      requestParams = { page: 0, limit: 10 };
    }

    let params = new HttpParams();

    if ('order' in requestParams) {
      params = params.append(`order[${requestParams.order.active}]`, requestParams.order.direction.toUpperCase());
    }
    if ('page' in requestParams) {
      params = params.append('page', requestParams.page.toString());
    }
    if ('limit' in requestParams) {
      params = params.append('limit', requestParams.limit.toString());
    }

    return this.http.get('/achievment/list', {params}, this.appLang);
  }

  saveAchievements(achievement) {
    return new Promise((resolve, reject) => {
      this.http.postForm('/apps/update/save', achievement, this.appLang).subscribe((res) => {
        if (res && res.success === true) {
          resolve(res.data);
        }
      }, (err) => {
        reject(err);
      });
    });
  }

  deleteAchievement(index) {
    return this.http.delete(`/achievment/${index}`);
  }

  update() {
      this.http.post('/apps/update', { update: true }, this.appLang).subscribe((data) => {

        if (!data?.success){
       alert('Error')
     }
        //todo get response and popup
      });
  }

  saveApp(app) {
    return new Promise((resolve, rejects) => {
      this.http.post('/apps/save', app).subscribe((data) => {
        if (data?.success) {
          resolve(true);
        }
      }, (error) => {
        rejects(error);
      })
    })
  }

  editApp(id, app) {
    return new Promise((resolve, rejects) => {
      this.http.postForm(`/apps/${id}`, app).subscribe((data) => {
        if (data?.success) {
          resolve(data?.data);
        }
      }, (error) => {
        rejects(error);
      })
    })
  }

  saveUpdate(formValue, appLang?) {
    return new Promise((resolve, reject) => {
      this.http.postForm('/apps/update/save', formValue, this.appLang).subscribe((data) => {
        resolve(data?.data);
      }, (err) => {
        reject(err);
      })
    });
  }

  getAppById(id) {
    return new Promise((resolve, rejects) => {
      this.http.get(`/apps/${id}`).subscribe((data) => {
        if (data?.success) {
          this._appLang$.next(data?.data?.lang)
          this.checkUpdate();
          resolve(data?.data);
        }
      }, (error) => {
        rejects(error);
      })
    });
  }

}
